import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { SubscriptionCategory } from '@modules/subscriptions/interfaces/subscription-category';
import { Subscription } from '@subscriptions/interfaces/subscription';
import SubscriptionConfirmationModal from '@subscriptions/components/modals/subscription-confirmation-modal/subscription-confirmation-modal.vue';
import SubscriptionConfirmedModal from '@subscriptions/components/modals/subscription-confirmed-modal/subscription-confirmed-modal.vue';
import AddSubscriptionToShoppingCartModal from '@subscriptions/components/modals/add-subscription-to-shopping-cart-modal/add-subscription-to-shopping-cart-modal.vue';
import { Contact } from '@contacts/interfaces/contact';
import _ from 'lodash';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';
import BcSubscriptionCategoryForm from '@subscriptions/components/forms/subscription-category-form.vue';
import SubscriptionCategoryForm from '@subscriptions/components/forms/subscription-category-form.vue';

library.add(faSync);

@Component({
  name: 'bpc-subscription-category-table',
  components: {
    BcSubscriptionCategoryForm,
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-subscription-confirmation-modal': SubscriptionConfirmationModal,
    'bpc-subscription-confirmed-modal': SubscriptionConfirmedModal,
    'bpc-subscription-to-shopping-cart-modal': AddSubscriptionToShoppingCartModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
  },
})
export default class SubscriptionCategoryTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    buySubscriptionModal: InstanceType<typeof AddSubscriptionToShoppingCartModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    subscriptionConfirmationModal: InstanceType<typeof SubscriptionConfirmationModal> & {
      onOpenModal(): void;
      onCloseModal(): void;
    };
    subscriptionConfirmedModal: InstanceType<typeof SubscriptionConfirmedModal> & {
      onOpenModal(): void;
      onCloseModal(): void;
    };
    subscriptionCategoryForm: InstanceType<typeof SubscriptionCategoryForm> & {
      saveEntity(): void;
      formModel: Partial<SubscriptionCategory>;
    };
  };
  @Prop(String) readonly displayConfigName: string;
  @Prop({ type: Array, default: null }) readonly selectConfigName: string[];
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;
  @Prop(Array) readonly contacts: Contact[];
  @Prop({ type: Boolean, default: true }) readonly showTableHeader: boolean;

  public entity: SubscriptionCategory = null;
  public entityName = 'subscription-category';
  public pluralEntityName = 'subscription-categories';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public permissionEntityNameToUse = 'subscriptions';
  public selectedSubscriptionToBuy: SubscriptionCategory = null;
  public contactsToBuySubscription: number[] = [];
  public confirmedSubscriptions: Subscription[] = [];

  get shoppingCartActivated(): boolean {
    return this.$store.getters['centerSettings/shoppingCartActivated'];
  }

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  customRowActions = {
    details: {
      activated: true,
      type: 'action',
      icon: 'eye',
      show: true,
      text: 'details',
      event: 'details',
    },
    show: {
      activated: true,
      type: 'action',
      icon: 'plus',
      show: true,
      text: 'show',
      event: 'show',
    },
    buy: {
      activated: false,
      type: 'action',
      icon: 'shopping-cart',
      show: true,
      text: 'buy',
      event: 'buy',
      permissions: ['buy'],
    },
  };

  onFormSave(next: string = '') {
    this.nextAction = next;
    this.$refs.subscriptionCategoryForm.saveEntity();
  }

  onFormSaveAndNew() {
    this.nextAction = 'new';
    this.$refs.subscriptionCategoryForm.saveEntity();
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as SubscriptionCategory;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(this.$refs.subscriptionCategoryForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  customOnRowAction($event: { event: string; item: any }) {
    if ($event.item.item.actions[$event.event].activated) {
      switch ($event.event) {
        case 'details':
          this.$router.push({
            name: 'public-subscription-category-details',
            params: { subscriptionCategoryId: $event.item.item.id },
          });
          break;
        case 'show':
          this.$router.push('subscription-category-details/' + $event.item.item.id);
          break;
        case 'buy':
          this.showBuySubscriptionModal($event.item.item);
          break;
      }
    }
  }

  showBuySubscriptionModal(subscriptionCategory) {
    this.selectedSubscriptionToBuy = subscriptionCategory;
    console.log('selectedSubscriptionToBuy', subscriptionCategory);
    const isUnlimited = _.isNull(this.selectedSubscriptionToBuy.remaining_subscriptions);
    console.log('UNLIMITED', isUnlimited);
    if (
      isUnlimited ||
      (!isUnlimited && this.selectedSubscriptionToBuy?.remaining_subscriptions > 0)
    ) {
      this.$refs.buySubscriptionModal.onOpenModal(subscriptionCategory.id);
    }
    this.contactsToBuySubscription = [];
  }

  onSuccessSubscriptionCreation(subscriptions: Subscription[]) {
    this.confirmedSubscriptions = subscriptions;
    this.$refs.buySubscriptionModal.onCloseModal();
    if (this.shoppingCartActivated) {
      this.$refs.subscriptionConfirmationModal.onOpenModal();
    } else {
      this.$refs.subscriptionConfirmedModal.onOpenModal();
    }
    this.$refs.provider.getEntities();
    this.$root.$emit('refresh-orders');
  }

  onCloseConfirmationModal($event) {
    this.$refs.provider.getEntities();
  }

  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;
  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }
  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }
  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }

  bulkMoveToTrashDataToShow = [['code', 'name']];

  // Bulk restore modal (recover)
  showBulkRecoverModal = false;
  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }
  onCLoseBulkRecover() {
    this.showBulkRecoverModal = false;
  }
  onSuccessBulkRecover() {
    this.$refs.provider.getEntities();
  }

  bulkRecoverDataToShow = [['code', 'name']];
}
